module.exports = __webpack_public_path__ + "media/pdf/BoniM_Datenschutzaufklaerung_032023-b5e03d14370277d994a33cfb666caada.pdf";